/**
 * Intervention Schemas
 */

import { z } from 'zod';

export const interventionTypeSchema = z.enum([
  'support',
  'training',
  'mentoring',
  'coaching',
  'emergency',
]);

export const interventionPrioritySchema = z.enum(['low', 'medium', 'high', 'urgent']);

export const interventionStatusSchema = z.enum([
  'pending',
  'scheduled',
  'in_progress',
  'completed',
  'cancelled',
]);

export const createInterventionSchema = z.object({
  talentId: z.uuid(),
  journeyInstanceId: z.uuid().optional(),
  type: interventionTypeSchema,
  priority: interventionPrioritySchema.default('medium'),
  title: z.string().min(1).max(200),
  description: z.string().max(2000).optional(),
  scheduledAt: z.coerce.date().optional(),
  assignedTo: z.uuid().optional(),
  notes: z.string().max(2000).optional(),
});

export type CreateInterventionInput = z.infer<typeof createInterventionSchema>;

export const updateInterventionSchema = z.object({
  type: interventionTypeSchema.optional(),
  priority: interventionPrioritySchema.optional(),
  title: z.string().min(1).max(200).optional(),
  description: z.string().max(2000).optional(),
  status: interventionStatusSchema.optional(),
  scheduledAt: z.coerce.date().optional(),
  assignedTo: z.uuid().optional(),
  notes: z.string().max(2000).optional(),
  completedAt: z.coerce.date().optional(),
  outcome: z.string().max(2000).optional(),
});

export type UpdateInterventionInput = z.infer<typeof updateInterventionSchema>;
